// The screen a staff member lands on right after logging in (and whenever
// they're routed back into /staff with no more specific destination in
// mind — e.g. session-restore on app reload). Change this single value to
// point staff logins at a different landing page; it must be a valid path
// under the "staff" route (see app-routing.module.ts's staff children).
export const STAFF_DEFAULT_SCREEN = 'classes';
